export const REQUIRED_KEEPER_RESEARCH_SOURCE_TYPES = [
  'adp',
  'consensus_rank',
  'projection_set',
  'player_news',
  'depth_chart',
  'league_scoring',
];

function normalizeSourceType(type) {
  return String(type || '').trim().toLowerCase();
}

function parseDate(value) {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function sourceTypesInLedger(sourceLedger = []) {
  return new Set(sourceLedger.map((source) => normalizeSourceType(source.type)).filter(Boolean));
}

export function missingRequiredSourceTypes(
  sourceLedger = [],
  requiredTypes = REQUIRED_KEEPER_RESEARCH_SOURCE_TYPES
) {
  const present = sourceTypesInLedger(sourceLedger);
  return requiredTypes.filter((type) => !present.has(type));
}

export function buildSourceCoverage(sourceLedger = []) {
  const present = sourceTypesInLedger(sourceLedger);

  return REQUIRED_KEEPER_RESEARCH_SOURCE_TYPES.map((type) => ({
    type,
    covered: present.has(type),
  }));
}

export function isResearchRefreshDue(nextRefreshDate, currentDate = new Date()) {
  const next = parseDate(nextRefreshDate);
  const current = parseDate(currentDate);
  if (!next || !current) return false;

  return current >= next;
}

export function evidenceGradeForDossier(dossier = {}) {
  if (dossier.isDemo) return 'DEMO';

  const missing = missingRequiredSourceTypes(dossier.sourceLedger);
  if (!dossier.rosterSourceCaptured || !dossier.waiverCostConfirmed) return 'BLOCKED';
  if (missing.length >= 3) return 'D';
  if (missing.length >= 1) return 'C';
  if ((dossier.sourceLedger || []).length < 8) return 'B';
  return 'A';
}

export function canPublishKeeperVerdict(dossier = {}) {
  return Boolean(
    !dossier.isDemo &&
    dossier.rosterSourceCaptured &&
    dossier.waiverCostConfirmed &&
    dossier.finalVerdictPublished &&
    missingRequiredSourceTypes(dossier.sourceLedger).length === 0
  );
}
